
import ToastificationContent from './ToastificationContent.vue'

const error = ({title, text}) => ({
  component: ToastificationContent,
  position: 'top-right',
  props: {
    title: `Error: ${title}`,
    icon: 'AlertTriangleIcon',
    variant: 'danger',
    text
  },
})

const success = ({title, text}) => ({
  component: ToastificationContent,
  props: {
    title: `${title}`,
    icon: 'CheckIcon',
    variant: 'success',
    text
  },
})

const hwToast = { error, success }

export default hwToast